import { useNavigationLinksHook } from './apiHooks';

const checkInMainNav = (link: { label: string }, data: {
    label: string;
    linknav: string;
    trackingId: string;
    show: string;
    columns: {
        show: string;
        header: string;
        columnLinks: {
            description: string;
            url: string;
            show: string;
            label: string;
            linknav: string;
            trackingId: string
        }[]
    }[];
}[]) => (data.filter(
  (navLink: { label: string; }) => navLink.label === link.label) || []).length === 0;

export const useGetProfileLinksForMobile = () => {
  const { data } = useNavigationLinksHook();
  return data?.profileDrawer.filter(
    (links) => checkInMainNav(links, data?.mainNavigation || []) && links.show) || [];
};
